import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { SideBarBuyActionsContainer, SideBarSeeMoreButton } from './components';
import { LikeBondButtonOnBondSAccId } from '../../../../../../../../../../../../../../../../../../../../aws';

export const SideBarActions = () => (
  <SideBarBuyActionsContainer>
    <SideBarSeeMoreButton />
    <LikeBondButtonOnBondSAccId
      isFavoriteWhileLoading={false}
      backgroundColor={ouiStyle.Constants.Colors.inherit}
      color={ouiStyle.Constants.Colors.primary}
      hoverBackgroundColor={ouiStyle.Constants.Colors.fadeDarker}
      paddingHorizontal="simple"
      position="absolute"
      top={0}
      right="1.25rem"
    />
  </SideBarBuyActionsContainer>
);
